import { I_ConfigScene, I_Scene } from '@containers/Home/types/I_Scene';
import { selectDetailProject } from '@containers/Home/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const sceneViewRevision = (view?: I_ConfigScene) =>
  view
    ? JSON.stringify({
        limit_view: view.limit_view,
        zoom_limit: view.zoom_limit,
        default_view: view.default_view,
      })
    : '';

export const DEFAULT_SCENE_VIEW: Required<
  Pick<I_ConfigScene, 'limit_view' | 'zoom_limit' | 'default_view'>
> = {
  limit_view: {
    top: -90,
    bottom: 90,
    left: -180,
    right: 180,
  },
  zoom_limit: {
    min: 60,
    max: 150,
  },
  default_view: {
    x: 0,
    y: 0,
    zoom_lv: 90,
  },
};

export const mergeSceneView = (
  sceneConfig?: I_ConfigScene,
  projectGlobalViewConfig?: I_ConfigScene,
): Pick<I_ConfigScene, 'limit_view' | 'zoom_limit' | 'default_view'> => ({
  limit_view: {
    ...DEFAULT_SCENE_VIEW.limit_view,
    ...projectGlobalViewConfig?.limit_view,
    ...sceneConfig?.limit_view,
  },
  zoom_limit: {
    ...DEFAULT_SCENE_VIEW.zoom_limit,
    ...projectGlobalViewConfig?.zoom_limit,
    ...sceneConfig?.zoom_limit,
  },
  default_view: {
    ...DEFAULT_SCENE_VIEW.default_view,
    ...projectGlobalViewConfig?.default_view,
    ...sceneConfig?.default_view,
  },
});

export const withSceneView = (
  scene?: I_Scene,
  projectGlobalViewConfig?: I_ConfigScene,
): I_Scene | undefined => {
  if (!scene) return scene;
  const view = mergeSceneView(scene.config, projectGlobalViewConfig);
  return {
    ...scene,
    config: {
      ...scene.config,
      default_view: view.default_view,
      limit_view: view.limit_view,
      zoom_limit: view.zoom_limit,
    },
  };
};

export const useSceneView = (scene?: I_Scene) => {
  const project = useSelector(selectDetailProject);
  const globalView = project?.config?.setting?.view;
  return useMemo(() => withSceneView(scene, globalView), [scene, globalView]);
};
